import { render, staticRenderFns } from "./WonderOpportunityMining.vue?vue&type=template&id=a9e51a24&scoped=true"
import script from "./WonderOpportunityMining.vue?vue&type=script&lang=js"
export * from "./WonderOpportunityMining.vue?vue&type=script&lang=js"
import style0 from "./WonderOpportunityMining.vue?vue&type=style&index=0&id=a9e51a24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e51a24",
  null
  
)

export default component.exports